import { CaltivationCategoryOptions, ProductionHistoryOptions } from '../../../constants';
import type { BiddingInfo } from '../../../types';
import { useTruncatedTooltip } from '../../common/TruncatedTooltip';

// 詳細用Props
interface ListingScheduleDetailsProps {
  item: BiddingInfo;
  displayInfo: { totalCapacity: number };
}

// # 詳細コンポーネント ---
export const ListingScheduleDetails: React.FC<ListingScheduleDetailsProps> = ({ item }) => {

  const { TooltipElement } = useTruncatedTooltip();
  
  return (
    <div className="p-1 lg:p-4 border-t border-slate-200 bg-white">
      {/* PC: 6カラム, スマホ: 2カラム */}
      <div className="grid grid-cols-2 md:grid-cols-6 lg:gap-4">

        {/* 【グループA】GAP区分 / 栽培区分 / 生産履歴  */}
        <div className="col-span-2 grid grid-cols-3 items-center md:contents">

          {/* --- 1. GAP区分 --- */}
          <div className="md:col-span-1"><p className="hidden md:block text-base text-slate-500">GAP区分</p>
            <p className="text-base lg:text-lg lg:font-semibold ml-2.5 lg:ml-0">{item.gapName}</p>
          </div>

          {/* --- 2. 栽培区分 --- */}
          <div className="md:col-span-1">
            <p className="hidden md:block text-base text-slate-500">栽培区分</p>
            {(() => {
              const targetOption = CaltivationCategoryOptions.find(opt => opt.value === item.caltivationCategory);
              return (
                <p className="text-base lg:text-lg lg:font-bold ml-2 lg:ml-0">
                  {targetOption ? targetOption.label : <span className="text-slate-400">-</span>}
                </p>
              );
            })()}
          </div>

          {/* --- 3. 生産履歴 --- */}
          <div className="md:col-span-1">
            <p className="hidden md:block text-base text-slate-500">生産履歴</p>
            <div className="flex items-center">
              {/* <span className="md:hidden text-sm text-slate-500 mr-2">生産履歴:</span> */}
              {(() => {
                const targetOption = ProductionHistoryOptions.find(opt => opt.value === item.productionHistory);
                return (
                  <p className="text-base lg:text-lg lg:font-bold -ml-2.5 lg:ml-0">
                    {targetOption ? targetOption.label : <span className="text-slate-400">-</span>}
                  </p>
                );
              })()}
            </div>
          </div>

        </div>

        {/* 容量① / 容量② / 最低落札値 */}
        <div className="col-span-2 flex flex-wrap items-end justify-between gap-x-4 gap-y-2 lg:mt-2 lg:pt-2 md:contents md:border-0 md:mt-0 md:pt-0">
          
          {/* 左側に容量などをまとめるため(スマホ用) */}
          <div className="flex flex-wrap gap-x-4 gap-y-2 md:contents">
            
            {/* --- 4. 容量・本数 ① --- */}
            {(Number(item.capacity1) > 0 && Number(item.quantity1) > 0) && (
              <div className="md:col-span-1">
                <p className="hidden md:block text-sm lg:text-base text-slate-500">容量(kg)/本数(本) ①</p>
                <p className="text-lg lg:font-bold ml-2.5 lg:ml-0 ">
                  {item.capacity1}<span className="text-sm font-normal ml-0.5 md:hidden">kg</span> × {item.quantity1}<span className="text-sm font-normal ml-0.5 md:hidden">本</span>
                </p>
              </div>
            )}

            {/* --- 5. 容量・本数 ② --- */}
            {(Number(item.capacity2) > 0 && Number(item.quantity2) > 0) && (
              <div className="md:col-span-1">
                <p className="hidden md:block text-sm lg:text-base text-slate-500">容量(kg)/本数(本) ②</p>
                <p className="text-lg lg:font-bold ml-3 lg:ml-0">
                  {item.capacity2}<span className="text-sm font-normal ml-0.5 md:hidden">kg</span> × {item.quantity2}<span className="text-sm font-normal ml-0.5 md:hidden">本</span>
                </p>
              </div>
            )}

          </div>

          {/* --- 6. 最低落札値 (スマホでは右寄せ) --- */}
          {/* flex-1 をつけて余った右側のスペースに押しやる */}
          <div className="flex-1 md:flex-none md:col-span-1 flex justify-end md:block">
            <div className="text-right md:text-left">
               <p className="hidden md:block text-sm lg:text-base text-slate-500">最低落札値(円)</p>
               <p className='text-2xl md:text-lg font-bold md:font-semibold text-slate-900'>
                 {Number(item.bidMinPrice) > 0 ? Number(item.bidMinPrice).toLocaleString() : '-'}
                 <span className="text-sm font-normal ml-1 md:hidden text-slate-600">円</span>
               </p>
            </div>
          </div>
        </div> 

        {item.biko && (
          <div className="col-span-2 md:col-span-6 mt-3 pt-3 border-t border-dashed border-slate-200">
            <p className="hidden md:block text-sm lg:text-base text-slate-500">
              備考
            </p>
            <p className="text-base ml-2.5 lg:ml-0 whitespace-pre-wrap text-slate-700 leading-relaxed">
              {item.biko}
            </p>
          </div>
        )}
      </div>
      {TooltipElement}
    </div>
  );
  
};